<template>
  <section class="container is-fluid">
    <div class="is-neon-persist">
      <div class="card">
        <div class="card-content">
          <span class="title">Vous êtes:</span>
          <hr class="is-success" />

          <div class="column is-12 columns is-multiline">
            <b-field label="Nom" class="column">
              <b-input type="text" v-model="profileData.lastName"></b-input>
            </b-field>
            <b-field label="Prénom" class="column">
              <b-input type="text" v-model="profileData.firstName"></b-input>
            </b-field>

            <b-field label="Email" class="column">
              <b-input
                type="email"
                v-model="profileData.mail"
                disabled
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="is-neon-persist">
      <div class="card">
        <div class="card-content">
          <span class="title">Vos coordonées:</span>
          <hr class="is-success" />

          <div class="column is-12 columns is-multiline">
            <b-field label="Pays" class="column is-4">
              <b-input v-model="profileData.fullAddress.country"></b-input>
            </b-field>

            <b-field label="Code Postal" class="column is-4">
              <b-input v-model="profileData.fullAddress.postalCode"></b-input>
            </b-field>
            <b-field label="Ville" class="column is-4">
              <b-input v-model="profileData.fullAddress.city"></b-input>
            </b-field>
            <b-field label="Adresse" class="column is-6">
              <b-input v-model="profileData.fullAddress.address"></b-input>
            </b-field>
            <b-field label="Numéro de téléphone" class="column">
              <b-input
                type="text"
                v-model="profileData.tel"
                maxlength="10"
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons is-centered" style="margin-top: 1.5em">
      <b-button type="is-success" @click="updateProfile">
        <span>Sauvegarder</span>
      </b-button>
    </div>
  </section>
</template>

<script>
import { auth } from "@/firebase";
const { Profile } = require("../classes/Profile.js");

export default {
  data() {
    return {
      errors: [],
      profileData: {
        lastName: "chargement...",
        firstName: "chargement...",
        fullAddress: {
          address: "chargement...",
          postalCode: "chargement...",
          city: "chargement...",
          country: "chargement...",
        },
      },
    };
  },
  created() {
    this.readData();
  },
  methods: {
    async updateProfile() {
      await this.profileData.updateProfile();
      this.$buefy.toast.open(`Votre profil a bien été mis à jour.`);
    },
    async readData() {
      const profile = new Profile(auth.currentUser.uid);
      await profile.getProfile();
      this.profileData = profile;
    },
  },
};
</script>